var React = require('react');
var ReactNative = require('react-native');

var {
  View,
  StyleSheet,
  ScrollView,
  Image,
  Text,
  PixelRatio,
  Platform
} = ReactNative;

var Navigator = require('./wrappers/Navigator-wrapper');

var Globals = require('./Globals');

var FeatureBuilder = require('./FeatureBuilder');
var ReUpIconButton = require('./ReUpIconButton');
var ReUpText = require('./ReUpText');
var FadingView = require('./FadingView');
var Animated = require('./wrappers/Animated');
var OffsetView = require('./OffsetView');

var ReUpFloatingNavigator = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      didMount: null,
      willUnmount: null,
      onDismiss: null,
      onShow: null,
      style:{},
      appManager:null,
      shouldUseTab: false,
      disableNavHeader: false,
    }
  },

  getInitialState : function()
  {
    return {
      height:200,//-1,
      width:200,//-1,
      enabled:false,
      viewOffset:null,
      shadowOpacity:new Animated.Value(0),
      shouldShowBack:false,
    }
  },

  componentDidMount : function()
  {
    if( this.props.didMount != null ) this.props.didMount(this);

    this._ref_scrollView.scrollTo({y:1})
    this._ref_scrollView.scrollTo({y:0})
  },

  componentWillUnmount : function()
  {
    if( this.props.willUnmount != null ) this.props.willUnmount(this);
  },

  _didDismiss : false,
  dismiss : function()
  {
    if( this._didDismiss ) return;
    this._didDismiss = true;
    this._didShow = false;

    var thisThing = this;
    if( this._ref_scrollView )
    {
      if( Platform.OS == 'web' )
      {
        var thisThing = this;
        var scrollOffsetY = new Animated.Value(this._scrollOffsetY);
        scrollOffsetY.addListener(({value})=>
        {
          thisThing._ref_scrollView.scrollTo({y:value})
        });
        Animated.timing(scrollOffsetY,
        {
          toValue:0,
          duration:200
        }).start(()=>
        {
          thisThing._nav.popToTop();
          thisThing._didShow = false;
          thisThing._nav.replace({});
        })
      }
      else
      {
        this._ref_scrollView.scrollTo({y:0});

    thisThing._didShow = false;

        setTimeout(()=>
        {
          if( thisThing._didDismiss )
          {
            thisThing._nav.replace({});
          }
        },400);
      }
    }
    this.setState({enabled:false});

    if( this.props.onDismiss != null ) this.props.onDismiss();

    setTimeout(()=>
    {
      if( thisThing._didDismiss )
      {
        thisThing._nav.popToTop();
        thisThing._nav.replace({});
      }
    },400);
  },

  _didShow : false,
  show : function()
  {
    if( this._didShow ) return false;
    this._didShow = true;
    this._didDismiss = false;

    this.setState({shouldShowBack:false});
    var thisThing = this;
    if( this._ref_scrollView )
    {
      if( Platform.OS == 'web' )
      {
        var thisThing = this;
        var scrollOffsetY = new Animated.Value(this._scrollOffsetY);
        scrollOffsetY.addListener(({value})=>
        {
          thisThing._ref_scrollView.scrollTo({y:value})
        });
        Animated.timing(scrollOffsetY,
        {
          toValue:this.state.height,
          duration:200
        }).start()
      }
      else
      {
        this._ref_scrollView.scrollTo({y:this.state.height})
      }
    }
    if( thisThing.props.onShow != null ) thisThing.props.onShow(this);

    return true;
  },

  pushFeature : function(feature, extras, shouldAnimate)
  {
    if( typeof extras === 'undefined' ) extras = {};
    if( typeof feature.extras !== 'undefined' )
    {
      for( var key in feature.extras )
      {
        extras[key] = feature.extras[key]
      }
    }
    extras.shouldHideActionBar = true;
    feature.extras = extras;
    if( !this._didShow ) this._nav.resetTo(feature);
    else this._nav.push(feature);
    if( !this.show() ) this.setState({shouldShowBack:true})
  },

  popFeature : function()
  {
    var routeStack = this._nav.state.routeStack;
    if( routeStack.length <= 2 ) this.setState({shouldShowBack:false});
    if( routeStack.length <= 1 ) this.dismiss();
    else this._nav.pop();
  },

  replace : function(feature, extras)
  {
    if( typeof extras === 'undefined' ) extras = {};
    if( typeof feature.extras !== 'undefined' )
    {
      for( var key in feature.extras )
      {
        extras[key] = feature.extras[key]
      }
    }
    extras.shouldHideActionBar = true;
    feature.extras = extras;

    this.show();
    this._nav.replace(feature);
  },

  isShown : function()
  {
    return this._didShow;
  },

  viewDidLayout : function(info)
  {
    var currentLayout = info.nativeEvent.layout;
    this.setState({height:currentLayout.height, width:currentLayout.width});
    if( !this._didShow ) this.setState({viewOffset:new Animated.Value(currentLayout.height)})
  },

  _lastYOffset : -100000000,
  render: function()
  {
    var {style, didMount, willUnmount, ...otherProps} = this.props;

    var thisThing = this;

    var featureView = null;

    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var appActions = this.props.appActions;

    // var featureView = FeatureBuilder.featureForData(thisThing.props.appManager.getFeatureForName("UseCredit"), {width:thisThing.state.width, height:thisThing.state.height}, thisThing.props.appManager, {shouldHideActionBar:true});;

    var headerColor = appManager.getColorForKey("HeaderColor");
    var headerIconColor = appManager.getColorForKey("HeaderIconColor");
    var generalColor = appManager.getColorForKey("GeneralColor");

    var shouldShowClose = true;

    var headerPath = appManager.absoluteResourceForPath('Feed'+'/'+'header.png');

    var bottomBufferHeight = 400;

    // TODO: figure this out... for some reason adding the offsetview makes it so that tabs can't be pressed
    var VerticalScrollClass = Platform.OS == 'web' ? OffsetView : ScrollView;

    var navStyles = Navigator.NavigationBar.Styles;
    if( Platform.OS == 'ios' )
    {
      navStyles.General.TotalNavHeight = Globals.NAV_BAR_HEIGHT + 20;
      navStyles.Stages.Left.LeftButton.height = Globals.NAV_BAR_HEIGHT;
      navStyles.Stages.Left.RightButton.height = Globals.NAV_BAR_HEIGHT;
      navStyles.Stages.Center.LeftButton.height = Globals.NAV_BAR_HEIGHT;
      navStyles.Stages.Center.RightButton.height = Globals.NAV_BAR_HEIGHT;
      navStyles.Stages.Right.LeftButton.height = Globals.NAV_BAR_HEIGHT;
      navStyles.Stages.Right.RightButton.height = Globals.NAV_BAR_HEIGHT;
    }

    return(
      <View pointerEvents={"none"} style={[style, {opacity:this.state.height>0 ? 1 : 0}]} onLayout={this.viewDidLayout} {...otherProps}>
        <FadingView ref={(c) => { this._ref_fadingView = c; }} pointerEvents={"none"} style={{position:'absolute', pointerEvents:'none', top:0, left:0, right:0, bottom:0, backgroundColor:'rgba(0,0,0,.4)'}} />
      {
        true ?
          <Animated.View pointerEvents={"none"} style={{pointerEvents:'none', position:'absolute', top:0, left:0, right:0, height:this.state.height-(this.props.disableNavHeader ? Globals.ACTION_BAR_HEIGHT : 0)}}>
            <VerticalScrollClass ref={(c) => { this._ref_scrollView = c; }}
              pointerEvents={Platform.OS == 'web' ? (this.state.enabled ? "none" : "none") : "box-none"}
              scrollEnabled={Platform.OS === 'ios'}
              bounces={false} showsVerticalScrollIndicator={false} decelerationRate={"fast"} scrollEventThrottle={40}
              keyboardShouldPersistTaps="always"
              snapToInterval={this.state.height}
              style={{flex:1, alignSelf:'stretch', flexDirection:'column'}} scrollEventThrottle={20} onScroll={(info)=>
              {
                if( typeof info.nativeEvent.contentOffset === 'undefined' ) return;

                var newYOffset = info.nativeEvent.contentOffset.y;
                thisThing._scrollOffsetY = newYOffset;
                if( thisThing._lastYOffset < newYOffset && newYOffset > thisThing.state.height/2 )
                {
                  if( !thisThing.state.enabled ) thisThing.setState({enabled:true});
                }

                if( Platform.OS === 'ios' )
                {
                  if( thisThing._lastYOffset > newYOffset && newYOffset < thisThing.state.height/4 )
                  {
                    if( thisThing.state.enabled ) thisThing.setState({enabled:false});
                  }
                }
                else
                {
                  if( thisThing._lastYOffset > newYOffset && newYOffset < 4*thisThing.state.height/5 )
                  {
                    if( thisThing.state.enabled ) thisThing.setState({enabled:false});
                    setTimeout(()=>
                    {
                      thisThing.dismiss();
                    }, 20)
                  }
                }

                if( thisThing._lastYOffset > newYOffset && newYOffset < 20 )
                {
                  thisThing.dismiss();
                }

                thisThing._ref_fadingView.setOpacity(newYOffset/thisThing.state.height)

                thisThing._lastYOffset = newYOffset;
              }}>
              <View pointerEvents="none" style={{height:this.state.height, width:100}} />
              <View pointerEvents="auto" style={{overflow:'hidden', pointerEvents:'auto', flexDirection:'column', marginTop:this.props.ignoreStatusBar ? 0 : Globals.STATUS_BAR_HEIGHT, height:this.state.height - (this.props.ignoreStatusBar ? 0 : Globals.STATUS_BAR_HEIGHT) - (this.props.disableNavHeader ? Globals.ACTION_BAR_HEIGHT : 0), alignSelf:'stretch', borderTopLeftRadius:10, borderTopRightRadius:10, backgroundColor:generalColor}}>
                {
                  !this.props.disableNavHeader ?
                    <View style={{position:'absolute', left:0, top:0, right:0, height:Globals.ACTION_BAR_HEIGHT-Globals.STATUS_BAR_HEIGHT, alignSelf:'stretch', backgroundColor:headerColor}} />
                  : null
                }
                <Navigator
                  ref={(a)=>{if( a != null ) thisThing._nav = a;}}
                  renderScene={(route, navigator) =>
                    {
                      if( typeof route === 'undefined' ) return null;
                      if( typeof route.data === 'undefined' ) return null;

                      return FeatureBuilder.featureForData(route, {width:thisThing.state.width, height:thisThing.state.height}, appManager, route.extras);
                    }
                  }
                  style={{width:thisThing.state.width, height:thisThing.state.height-Globals.STATUS_BAR_HEIGHT, paddingTop: (this.props.disableNavHeader ? 0 : Globals.ACTION_BAR_HEIGHT) - (this.props.ignoreStatusBar ? Globals.STATUS_BAR_HEIGHT : 0), marginTop:this.props.ignoreStatusBar ? 0 : -Globals.STATUS_BAR_HEIGHT}}
                  navigationBar={this.props.disableNavHeader ? null :
                     <Navigator.NavigationBar
                       navigationStyles={navStyles} 
                       routeMapper={{
                         LeftButton: (route, navigator, index, navState) =>
                          {
                            if( typeof route === 'undefined' ) return null;
                            if( typeof route.data === 'undefined' ) return null;
                            if( !thisThing.state.shouldShowBack )
                            {
                              return <View style={[{margin:0}, Globals.TOP_LEFT_STYLE_ADJUSTMENT]}>
                                <ReUpIconButton key={"angle-down"}
                                  iconName={"angle-down"}
                                  appManager={appManager}
                                  type={2}
                                  accessibilityLabel={locManager.localizedStringForKey("MENU_ACCESSIBILITY_BUTTON")}
                                  onPress={()=>
                                  {
                                    appActions.requestPop();
                                  }}
                                  style={[{margin:0}]}/>
                              </View>
                            }

                            return <View style={[{margin:0}, Globals.TOP_LEFT_STYLE_ADJUSTMENT]}>
                              <ReUpIconButton key={"angle-left"}
                                iconName={"angle-left"}
                                appManager={appManager}
                                type={2}
                                accessibilityLabel={locManager.localizedStringForKey("BACK_ACCESSIBILITY_BUTTON")}
                                style={[{margin:0}]}
                                onPress={()=>
                                {
                                  appActions.requestPop();
                                }}/>
                            </View>;
                          },
                         RightButton: (route, navigator, index, navState) =>
                           {
                             if( typeof route === 'undefined' ) return null;
                             if( typeof route.data === 'undefined' ) return null;
                             var topRightFeatures = appManager.getTopRightFeatures();
                             if( topRightFeatures.length <= 0 ) return <View />;

                             var feature = topRightFeatures[0];
                             if( feature.data.name == route.data.name || typeof feature === 'undefined' ) return <View />;
                             if( feature.data.requiresLogin && !appManager.isLoggedIn() ) return <View />;
                             for( var i = 0, len = navState.routeStack.length; i < len && i < navState.routeStack.length; i++ )
                             {
                               var thisFeature = navState.routeStack[i];
                               if( typeof thisFeature.data === 'undefined' || thisFeature.data.name == feature.data.name )
                               {
                                 return <View />;
                               }
                             }

                             var thisThing = this;
                             var iconName = feature.data.icon.replace("fa-", "")
                             return <View style={[{margin:0}, Globals.TOP_LEFT_STYLE_ADJUSTMENT]}>
                               <ReUpIconButton key={iconName}
                                 iconName={iconName}
                                 appManager={appManager}
                                 type={2}
                                 accessibilityLabel={locManager.localizedStringForKey("BACK_ACCESSIBILITY_BUTTON")}
                                 onPress={()=>
                                 {
                                   if( thisThing._topRightDisabled ) return;
                                   thisThing._topRightDisabled = true;
                                   setTimeout(function()
                                   {
                                     thisThing._topRightDisabled = false;
                                   },2000)
                                   appActions.requestFeatureName(feature.data.name);
                                 }}/>
                               </View>;
                           },
                         Title: (route, navigator, index, navState) =>
                           {
                             if( typeof route === 'undefined' ) return null;
                             if( typeof route.data === 'undefined' ) return null;
                             if( route.data.headerImage && route.data.headerImage.trim().length > 0 )
                             {
                               var headerPath = appManager.absoluteResourceForPath(route.key+'/'+route.data.headerImage);
                               return (
                                 <View
                                  style={[styles.navBarTitleContainer, {marginRight:Platform.OS == "android" ? 70 : 0}, Globals.TOP_CENTER_ADJUSTMENT]}>
                                   <Image style={[styles.navBarTitleImage]} resizeMode={"stretch"} source={{uri: headerPath}}/>
                                 </View>
                               );
                             }
                             else
                             {
                               return (
                                 <View
                                   style={[styles.navBarTitleContainer, {marginRight:Platform.OS == "android" ? 70 : 0}, Globals.TOP_CENTER_TEXT_ADJUSTMENT]}>
                                   <View style={{alignSelf:'center'}}>
                                     <ReUpText appManager={appManager} isSuperTitle={true} shrinksAtLength={20} style={[styles.navBarTitleText, {color: appManager.getColorForKey("HeaderTitleColor")}]}>
                                       {route.data.title}
                                     </ReUpText>
                                   </View>
                                 </View>
                               );

                             }
                           },
                       }}
                       style={{backgroundColor: 'transparent', height:Globals.NAV_BAR_HEIGHT, padding:0, flex:-1}}
                     />
                  }
                />
              </View>
            </VerticalScrollClass>
          </Animated.View>
        : null
      }
      </View>
    )
  }
});

module.exports = ReUpFloatingNavigator;



// <View style={{overflow:'hidden', marginTop:Globals.STATUS_BAR_HEIGHT, height:this.state.height - Globals.STATUS_BAR_HEIGHT, alignSelf:'stretch', borderTopLeftRadius:10, borderTopRightRadius:10, backgroundColor:generalColor}}>
//   <View style={{alignSelf:'stretch', flexDirection:'row', height:Globals.ACTION_BAR_HEIGHT - Globals.STATUS_BAR_HEIGHT, backgroundColor:headerColor}}>
//     <View style={{width:50, marginLeft:10}}>
//       <ReUpIconButton key={shouldShowClose ? "angle-down" : "angle-left"}
//         iconName={shouldShowClose ? "angle-down" : "angle-left"}
//         appManager={appManager}
//         buttonColorOverride={headerColor}
//         type={2}
//         accessibilityLabel={"Menu"}
//         onPress={()=>
//         {
//           if( shouldShowClose ) thisThing.dismiss();
//         }}/>
//     </View>
//     <View style={{flex:1, alignItems:'center'}}>
//       <Image style={{
//         height:44,
//         width:150,
//         padding:0,
//         flex:-1,
//       }} resizeMode={"stretch"} source={{uri: headerPath}}/>
//     </View>
//    <View style={{marginRight:10}}>
//      <ReUpIconButton key={"usd"}
//        iconName={"usd"}
//        appManager={appManager}
//        buttonColorOverride={headerColor}
//        type={2}
//        accessibilityLabel={"Menu"}
//        onPress={()=>
//        {
//          if( shouldShowClose ) thisThing.dismiss();
//        }}/>
//     </View>
//   </View>
//   {
//     featureView
//   }
var styles = StyleSheet.create({
  floatView: {
    position: 'absolute',
    backgroundColor:'transparent',
    flex:1,
    width:0,
    height:0,
    top: Globals.ACTION_BAR_HEIGHT,
    left: 0,
  },
  container: {
    flex: 1,
    alignItems: 'stretch',
  },
  messageText: {
    fontWeight: '500',
    padding: 15,
    marginTop: 50,
    marginLeft: 15,
  },
  button: {
    backgroundColor: 'white',
    padding: 15,
    borderBottomWidth: 1 / PixelRatio.get(),
    borderBottomColor: '#CDCDCD',
  },
  buttonText: {
  },
  navBar: {
    backgroundColor: 'grey',
    padding:0,
    flex:-1,
  },
  navBarTitleImage: {
    height:44,
    width:150,
    padding:0,
    flex:-1,
  },
  navBarTitleContainer:{
    alignItems:'center',
    justifyContent:'center',
  },
  navBarText: {
    marginVertical: 10,
  },
  navBarTitleText: {
    alignItems:'center',
    justifyContent:'center',
    textAlign:'center',
  },
  navBarLeftButton: {
    flexDirection:'row',
    width:44,
    height:44,
    marginTop:6,
    borderRadius:22,
    alignItems:'center',
    justifyContent:'center',
    alignSelf:'center',
    backgroundColor:'transparent',
  },
  navBarRightButton: {
    paddingRight: 10,
    flexDirection:'row',
    width:44,
    alignItems:'center',
    justifyContent:'center',
    flex:-1,
  },
  navBarButtonText: {
    color: 'green',
    paddingLeft:2,
    paddingTop:2,
  },
  scene: {
    flex: 1,
    paddingTop: 20,
    backgroundColor: '#EAEAEA',
  },
  menuContainerShown: {
    opacity: 1,
  },
  updateMeter: {
    position:'absolute',
    flexDirection:'row',
    top:0,
    left:0,
    right:0,
    height:2,
    backgroundColor:'transparent'
  },
  networkStatus: {
    position:'absolute',
    flexDirection:'row',
    left:0,
    right:0,
    height:30,
  }
});
